"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePassword = void 0;
const charClasses = [
    'abcdefghijklmnopqrstuvwwyz',
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    '0123456890',
    '+-^$*?!@#%_',
];
const minLength = 8;
const defaultLength = 16;
function generatePassword(length = defaultLength) {
    length = Math.max(length, minLength);
    let password = '';
    const missingCharClasses = new Set(charClasses);
    // generate chars from all classes while there's space
    while (password.length + missingCharClasses.size < length) {
        const charClass = randomItem(charClasses);
        missingCharClasses.delete(charClass);
        password += randomItem(charClass);
    }
    // now we must pick chars from the classes that were not included
    while (missingCharClasses.size > 0) {
        const charClass = randomItem([...missingCharClasses]);
        password += randomItem(charClass);
        missingCharClasses.delete(charClass);
    }
    return password;
}
exports.generatePassword = generatePassword;
function randomItem(items) {
    const i = Math.floor(Math.random() * items.length);
    return items[i];
}
